package pl.michal_cyran.brand_hub.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import pl.michal_cyran.brand_hub.HeroContainerStyle
import pl.michal_cyran.brand_hub.LightSectionStyle

@Composable
fun LightBackgroundSection(
    content: @Composable () -> Unit
) {
    Column(
        LightSectionStyle.toModifier().fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Box(
            HeroContainerStyle
                .toModifier()
                .maxWidth(1280.px)
        ) {
            content()
        }
    }
}